"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M3.25 22V3a.75.75 0 01.22-.53c.196-.196.562-.44 1.126-.666C5.47 1.454 6.595 1.25 8 1.25c1.375 0 2.318.27 4.279 1.054 1.79.716 2.596.946 3.721.946 1.22 0 2.156-.17 2.846-.446.226-.09.402-.183.535-.272.064-.042.092-.066.089-.062a.75.75 0 011.28.53v12a.75.75 0 01-.22.53c-.196.196-.562.44-1.126.666-.873.35-1.999.554-3.404.554-1.375 0-2.318-.27-4.279-1.054-1.79-.716-2.596-.946-3.721-.946-1.22 0-2.156.17-2.846.446a3.309 3.309 0 00-.404.191V22a.75.75 0 11-1.5 0zM8 13.25c1.375 0 2.318.27 4.279 1.054 1.79.716 2.596.946 3.721.946 1.22 0 2.156-.17 2.846-.446.158-.064.292-.128.404-.191V4.255c-.85.313-1.926.495-3.25.495-1.375 0-2.318-.27-4.279-1.054C9.931 2.98 9.125 2.75 8 2.75c-1.22 0-2.156.17-2.846.446a3.309 3.309 0 00-.404.191v10.358c.85-.313 1.926-.495 3.25-.495z"
  }));
};

SvgFlag.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
SvgFlag.defaultProps = {
  color: "currentColor",
  size: "24"
};
var _default = SvgFlag;
exports["default"] = _default;
module.exports = exports.default;